import classNames from "classnames"
import React, { useCallback, useState, useMemo } from "react"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { CurrentTapType } from "pages/vendor/Dashbaord/Dashbaord"

interface TabsProps {
  onChangeHandler: (tab: CurrentTapType) => void
}

export const Tabs: React.FC<TabsProps> = ({ onChangeHandler }) => {
  const { t } = useTranslation()
  const currentTapType: { value: CurrentTapType; label: string }[] =
    useMemo(() => {
      return [
        {
          value: CurrentTapType.orders,
          label: t("dashboard_orders"),
        },
        {
          value: CurrentTapType.products,
          label: t("dashboard_products"),
        },
        {
          value: CurrentTapType.coupons,
          label: t("dashboard_coupons"),
        },
        {
          value: CurrentTapType.Deliveries,
          label: t("dashboard_deliveries"),
        },
        {
          value: CurrentTapType.disputes,
          label: t("dashboard_disputes"),
        },
      ]
    }, [t])

  const [currentTap, setCurrentTap] = useState<{
    value: CurrentTapType
    label: string
  }>(currentTapType[0])

  const changeTabHandler = useCallback(
    (tab: { value: CurrentTapType; label: string }) => {
      setCurrentTap(tab)
      onChangeHandler(tab.value)
    },
    [setCurrentTap]
  )

  return (
    <div className="container-fluid p-0">
      <h4 className="font-size-16 text-capitalize fw-semibold">
        {t("dashboard_activitySummary")}
      </h4>
      <ul className="nav nav-pills mb-3 mt-3 px-2">
        {currentTapType.map(tab => (
          <li
            className="nav-item"
            style={{ flex: 1, textAlign: "center" }}
            key={tab.label}
          >
            <Link
              to="#"
              className={classNames(
                { active: currentTap.value === tab.value },
                "nav-link"
              )}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => changeTabHandler(tab)}
            >
              {tab.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
